module.exports = __webpack_public_path__ + "static/media/colicoli5.7b8b9601.webp";